const loansList = [{
    "LoanId": 1,
    "BookId": 80,
    "PersonId": 18,
    "LoanDate": "2022-10-25",
    "ReturnDate": "2020-11-24",
    "DueDate": "2022-07-28",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 2,
    "BookId": 83,
    "PersonId": 14,
    "LoanDate": "2021-12-18",
    "ReturnDate": "2022-12-03",
    "DueDate": "2022-03-10",
    "IsReturned": false,
    "RenewalCount": 1
  }, {
    "LoanId": 3,
    "BookId": 94,
    "PersonId": 25,
    "LoanDate": "2021-07-19",
    "ReturnDate": "2022-10-06",
    "DueDate": "2022-06-12",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 4,
    "BookId": 16,
    "PersonId": 72,
    "LoanDate": "2021-12-27",
    "ReturnDate": "2021-02-01",
    "DueDate": "2022-06-07",
    "IsReturned": false,
    "RenewalCount": 1
  }, {
    "LoanId": 5,
    "BookId": 29,
    "PersonId": 83,
    "LoanDate": "2020-10-19",
    "ReturnDate": "2021-05-18",
    "DueDate": "2021-10-05",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 6,
    "BookId": 95,
    "PersonId": 81,
    "LoanDate": "2020-12-31",
    "ReturnDate": "2022-10-20",
    "DueDate": "2020-12-25",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 7,
    "BookId": 81,
    "PersonId": 59,
    "LoanDate": "2022-10-18",
    "ReturnDate": "2022-02-06",
    "DueDate": "2022-10-27",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 8,
    "BookId": 13,
    "PersonId": 34,
    "LoanDate": "2020-09-28",
    "ReturnDate": "2022-12-30",
    "DueDate": "2022-11-30",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 9,
    "BookId": 54,
    "PersonId": 3,
    "LoanDate": "2021-02-10",
    "ReturnDate": "2022-09-22",
    "DueDate": "2021-01-02",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 10,
    "BookId": 11,
    "PersonId": 59,
    "LoanDate": "2021-05-01",
    "ReturnDate": "2022-02-28",
    "DueDate": "2022-02-21",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 11,
    "BookId": 50,
    "PersonId": 42,
    "LoanDate": "2022-04-04",
    "ReturnDate": "2020-01-18",
    "DueDate": "2021-10-26",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 12,
    "BookId": 56,
    "PersonId": 17,
    "LoanDate": "2022-12-24",
    "ReturnDate": "2020-07-12",
    "DueDate": "2021-03-17",
    "IsReturned": false,
    "RenewalCount": 4
  }, {
    "LoanId": 13,
    "BookId": 31,
    "PersonId": 99,
    "LoanDate": "2022-12-09",
    "ReturnDate": "2021-04-03",
    "DueDate": "2021-09-20",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 14,
    "BookId": 33,
    "PersonId": 1,
    "LoanDate": "2020-08-09",
    "ReturnDate": "2020-05-15",
    "DueDate": "2022-09-20",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 15,
    "BookId": 94,
    "PersonId": 9,
    "LoanDate": "2020-12-31",
    "ReturnDate": "2022-07-22",
    "DueDate": "2021-05-23",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 16,
    "BookId": 10,
    "PersonId": 49,
    "LoanDate": "2020-03-07",
    "ReturnDate": "2020-06-27",
    "DueDate": "2021-12-04",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 17,
    "BookId": 16,
    "PersonId": 31,
    "LoanDate": "2021-01-01",
    "ReturnDate": "2020-11-16",
    "DueDate": "2021-03-10",
    "IsReturned": true,
    "RenewalCount": 0
  }, {
    "LoanId": 18,
    "BookId": 90,
    "PersonId": 30,
    "LoanDate": "2020-10-24",
    "ReturnDate": "2020-07-28",
    "DueDate": "2021-06-10",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 19,
    "BookId": 37,
    "PersonId": 30,
    "LoanDate": "2022-09-15",
    "ReturnDate": "2021-12-24",
    "DueDate": "2022-01-18",
    "IsReturned": true,
    "RenewalCount": 0
  }, {
    "LoanId": 20,
    "BookId": 89,
    "PersonId": 67,
    "LoanDate": "2021-07-01",
    "ReturnDate": "2022-04-20",
    "DueDate": "2021-03-12",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 21,
    "BookId": 87,
    "PersonId": 80,
    "LoanDate": "2020-07-09",
    "ReturnDate": "2021-02-18",
    "DueDate": "2021-08-29",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 22,
    "BookId": 8,
    "PersonId": 42,
    "LoanDate": "2021-03-19",
    "ReturnDate": "2021-02-07",
    "DueDate": "2021-11-08",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 23,
    "BookId": 19,
    "PersonId": 97,
    "LoanDate": "2020-10-11",
    "ReturnDate": "2022-01-13",
    "DueDate": "2021-04-18",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 24,
    "BookId": 63,
    "PersonId": 27,
    "LoanDate": "2020-06-19",
    "ReturnDate": "2020-02-21",
    "DueDate": "2022-03-04",
    "IsReturned": false,
    "RenewalCount": 4
  }, {
    "LoanId": 25,
    "BookId": 15,
    "PersonId": 54,
    "LoanDate": "2020-01-10",
    "ReturnDate": "2021-07-01",
    "DueDate": "2020-06-13",
    "IsReturned": true,
    "RenewalCount": 0
  }, {
    "LoanId": 26,
    "BookId": 2,
    "PersonId": 87,
    "LoanDate": "2020-12-28",
    "ReturnDate": "2020-07-29",
    "DueDate": "2022-05-18",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 27,
    "BookId": 88,
    "PersonId": 77,
    "LoanDate": "2020-03-01",
    "ReturnDate": "2022-04-11",
    "DueDate": "2022-02-02",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 28,
    "BookId": 91,
    "PersonId": 60,
    "LoanDate": "2021-10-08",
    "ReturnDate": "2021-09-18",
    "DueDate": "2022-04-20",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 29,
    "BookId": 22,
    "PersonId": 83,
    "LoanDate": "2021-08-03",
    "ReturnDate": "2021-12-28",
    "DueDate": "2022-06-28",
    "IsReturned": false,
    "RenewalCount": 1
  }, {
    "LoanId": 30,
    "BookId": 7,
    "PersonId": 91,
    "LoanDate": "2020-08-20",
    "ReturnDate": "2021-04-29",
    "DueDate": "2020-12-09",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 31,
    "BookId": 55,
    "PersonId": 11,
    "LoanDate": "2020-09-20",
    "ReturnDate": "2022-01-20",
    "DueDate": "2022-05-04",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 32,
    "BookId": 27,
    "PersonId": 26,
    "LoanDate": "2020-07-19",
    "ReturnDate": "2022-08-23",
    "DueDate": "2020-09-16",
    "IsReturned": false,
    "RenewalCount": 4
  }, {
    "LoanId": 33,
    "BookId": 10,
    "PersonId": 52,
    "LoanDate": "2021-12-22",
    "ReturnDate": "2021-05-31",
    "DueDate": "2020-10-21",
    "IsReturned": false,
    "RenewalCount": 1
  }, {
    "LoanId": 34,
    "BookId": 6,
    "PersonId": 58,
    "LoanDate": "2021-02-21",
    "ReturnDate": "2021-05-17",
    "DueDate": "2022-12-29",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 35,
    "BookId": 24,
    "PersonId": 37,
    "LoanDate": "2020-11-21",
    "ReturnDate": "2022-01-14",
    "DueDate": "2021-02-27",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 36,
    "BookId": 93,
    "PersonId": 93,
    "LoanDate": "2021-02-28",
    "ReturnDate": "2020-05-01",
    "DueDate": "2020-04-12",
    "IsReturned": false,
    "RenewalCount": 4
  }, {
    "LoanId": 37,
    "BookId": 32,
    "PersonId": 38,
    "LoanDate": "2021-12-05",
    "ReturnDate": "2021-03-12",
    "DueDate": "2022-02-08",
    "IsReturned": true,
    "RenewalCount": 0
  }, {
    "LoanId": 38,
    "BookId": 50,
    "PersonId": 7,
    "LoanDate": "2020-08-04",
    "ReturnDate": "2021-11-04",
    "DueDate": "2021-08-31",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 39,
    "BookId": 61,
    "PersonId": 78,
    "LoanDate": "2020-04-07",
    "ReturnDate": "2021-09-23",
    "DueDate": "2022-11-11",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 40,
    "BookId": 18,
    "PersonId": 64,
    "LoanDate": "2020-01-04",
    "ReturnDate": "2021-10-07",
    "DueDate": "2022-02-08",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 41,
    "BookId": 47,
    "PersonId": 27,
    "LoanDate": "2021-06-11",
    "ReturnDate": "2020-06-09",
    "DueDate": "2020-05-29",
    "IsReturned": false,
    "RenewalCount": 1
  }, {
    "LoanId": 42,
    "BookId": 46,
    "PersonId": 34,
    "LoanDate": "2020-03-15",
    "ReturnDate": "2021-09-17",
    "DueDate": "2020-06-28",
    "IsReturned": true,
    "RenewalCount": 1
  }, {
    "LoanId": 43,
    "BookId": 35,
    "PersonId": 76,
    "LoanDate": "2022-06-03",
    "ReturnDate": "2021-10-08",
    "DueDate": "2021-08-19",
    "IsReturned": true,
    "RenewalCount": 0
  }, {
    "LoanId": 44,
    "BookId": 21,
    "PersonId": 84,
    "LoanDate": "2020-07-05",
    "ReturnDate": "2022-10-05",
    "DueDate": "2022-04-28",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 45,
    "BookId": 7,
    "PersonId": 23,
    "LoanDate": "2021-11-09",
    "ReturnDate": "2020-04-13",
    "DueDate": "2022-01-06",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 46,
    "BookId": 4,
    "PersonId": 8,
    "LoanDate": "2020-07-30",
    "ReturnDate": "2022-03-29",
    "DueDate": "2022-09-29",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 47,
    "BookId": 90,
    "PersonId": 71,
    "LoanDate": "2020-06-01",
    "ReturnDate": "2021-02-28",
    "DueDate": "2021-04-18",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 48,
    "BookId": 12,
    "PersonId": 26,
    "LoanDate": "2022-08-08",
    "ReturnDate": "2020-11-17",
    "DueDate": "2022-12-24",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 49,
    "BookId": 49,
    "PersonId": 92,
    "LoanDate": "2020-03-07",
    "ReturnDate": "2022-05-07",
    "DueDate": "2021-02-04",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 50,
    "BookId": 74,
    "PersonId": 65,
    "LoanDate": "2022-12-20",
    "ReturnDate": "2020-05-07",
    "DueDate": "2020-10-28",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 51,
    "BookId": 18,
    "PersonId": 4,
    "LoanDate": "2021-10-03",
    "ReturnDate": "2020-03-13",
    "DueDate": "2022-10-05",
    "IsReturned": true,
    "RenewalCount": 5
  }, {
    "LoanId": 52,
    "BookId": 62,
    "PersonId": 58,
    "LoanDate": "2020-06-14",
    "ReturnDate": "2020-11-04",
    "DueDate": "2020-01-10",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 53,
    "BookId": 55,
    "PersonId": 16,
    "LoanDate": "2022-08-13",
    "ReturnDate": "2021-09-29",
    "DueDate": "2020-10-07",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 54,
    "BookId": 95,
    "PersonId": 20,
    "LoanDate": "2021-10-29",
    "ReturnDate": "2020-09-10",
    "DueDate": "2022-04-03",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 55,
    "BookId": 25,
    "PersonId": 5,
    "LoanDate": "2021-07-12",
    "ReturnDate": "2020-05-04",
    "DueDate": "2022-02-22",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 56,
    "BookId": 10,
    "PersonId": 33,
    "LoanDate": "2022-08-30",
    "ReturnDate": "2022-09-08",
    "DueDate": "2020-07-17",
    "IsReturned": false,
    "RenewalCount": 4
  }, {
    "LoanId": 57,
    "BookId": 21,
    "PersonId": 97,
    "LoanDate": "2020-09-20",
    "ReturnDate": "2022-04-15",
    "DueDate": "2020-09-10",
    "IsReturned": true,
    "RenewalCount": 1
  }, {
    "LoanId": 58,
    "BookId": 25,
    "PersonId": 68,
    "LoanDate": "2020-09-07",
    "ReturnDate": "2022-04-22",
    "DueDate": "2022-02-08",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 59,
    "BookId": 9,
    "PersonId": 5,
    "LoanDate": "2020-09-18",
    "ReturnDate": "2022-06-25",
    "DueDate": "2020-05-09",
    "IsReturned": true,
    "RenewalCount": 5
  }, {
    "LoanId": 60,
    "BookId": 23,
    "PersonId": 57,
    "LoanDate": "2022-06-10",
    "ReturnDate": "2020-08-24",
    "DueDate": "2020-02-02",
    "IsReturned": true,
    "RenewalCount": 1
  }, {
    "LoanId": 61,
    "BookId": 89,
    "PersonId": 52,
    "LoanDate": "2020-02-20",
    "ReturnDate": "2022-10-30",
    "DueDate": "2020-02-04",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 62,
    "BookId": 43,
    "PersonId": 45,
    "LoanDate": "2021-10-10",
    "ReturnDate": "2020-02-03",
    "DueDate": "2020-04-12",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 63,
    "BookId": 90,
    "PersonId": 19,
    "LoanDate": "2021-08-26",
    "ReturnDate": "2020-11-03",
    "DueDate": "2020-07-20",
    "IsReturned": false,
    "RenewalCount": 1
  }, {
    "LoanId": 64,
    "BookId": 18,
    "PersonId": 51,
    "LoanDate": "2021-04-13",
    "ReturnDate": "2020-10-16",
    "DueDate": "2020-11-24",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 65,
    "BookId": 4,
    "PersonId": 58,
    "LoanDate": "2022-12-01",
    "ReturnDate": "2021-03-17",
    "DueDate": "2022-11-24",
    "IsReturned": false,
    "RenewalCount": 0
  }, {
    "LoanId": 66,
    "BookId": 50,
    "PersonId": 16,
    "LoanDate": "2020-07-16",
    "ReturnDate": "2021-08-17",
    "DueDate": "2022-07-08",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 67,
    "BookId": 86,
    "PersonId": 43,
    "LoanDate": "2021-08-24",
    "ReturnDate": "2020-09-14",
    "DueDate": "2021-08-05",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 68,
    "BookId": 17,
    "PersonId": 40,
    "LoanDate": "2022-07-24",
    "ReturnDate": "2020-10-27",
    "DueDate": "2020-06-25",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 69,
    "BookId": 62,
    "PersonId": 17,
    "LoanDate": "2021-08-04",
    "ReturnDate": "2022-08-06",
    "DueDate": "2021-12-22",
    "IsReturned": true,
    "RenewalCount": 0
  }, {
    "LoanId": 70,
    "BookId": 7,
    "PersonId": 20,
    "LoanDate": "2022-11-30",
    "ReturnDate": "2022-10-03",
    "DueDate": "2020-02-21",
    "IsReturned": true,
    "RenewalCount": 3
  }, {
    "LoanId": 71,
    "BookId": 19,
    "PersonId": 45,
    "LoanDate": "2022-03-14",
    "ReturnDate": "2021-12-01",
    "DueDate": "2022-06-27",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 72,
    "BookId": 7,
    "PersonId": 6,
    "LoanDate": "2021-09-13",
    "ReturnDate": "2021-06-21",
    "DueDate": "2021-01-24",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 73,
    "BookId": 66,
    "PersonId": 47,
    "LoanDate": "2021-04-23",
    "ReturnDate": "2020-04-11",
    "DueDate": "2020-08-17",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 74,
    "BookId": 16,
    "PersonId": 90,
    "LoanDate": "2022-08-10",
    "ReturnDate": "2020-05-12",
    "DueDate": "2022-09-03",
    "IsReturned": false,
    "RenewalCount": 4
  }, {
    "LoanId": 75,
    "BookId": 58,
    "PersonId": 97,
    "LoanDate": "2022-07-22",
    "ReturnDate": "2022-01-20",
    "DueDate": "2021-04-21",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 76,
    "BookId": 8,
    "PersonId": 70,
    "LoanDate": "2021-04-07",
    "ReturnDate": "2020-05-17",
    "DueDate": "2020-07-21",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 77,
    "BookId": 28,
    "PersonId": 85,
    "LoanDate": "2022-03-18",
    "ReturnDate": "2022-02-11",
    "DueDate": "2021-02-18",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 78,
    "BookId": 74,
    "PersonId": 63,
    "LoanDate": "2022-08-06",
    "ReturnDate": "2022-09-06",
    "DueDate": "2020-04-14",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 79,
    "BookId": 39,
    "PersonId": 78,
    "LoanDate": "2021-11-30",
    "ReturnDate": "2021-09-29",
    "DueDate": "2022-03-09",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 80,
    "BookId": 6,
    "PersonId": 95,
    "LoanDate": "2020-03-08",
    "ReturnDate": "2022-01-15",
    "DueDate": "2021-06-25",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 81,
    "BookId": 92,
    "PersonId": 25,
    "LoanDate": "2022-02-09",
    "ReturnDate": "2021-02-26",
    "DueDate": "2020-09-14",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 82,
    "BookId": 38,
    "PersonId": 52,
    "LoanDate": "2022-06-05",
    "ReturnDate": "2022-09-15",
    "DueDate": "2020-07-20",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 83,
    "BookId": 63,
    "PersonId": 83,
    "LoanDate": "2022-08-16",
    "ReturnDate": "2021-07-16",
    "DueDate": "2020-11-08",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 84,
    "BookId": 58,
    "PersonId": 70,
    "LoanDate": "2022-12-25",
    "ReturnDate": "2022-02-09",
    "DueDate": "2022-12-25",
    "IsReturned": true,
    "RenewalCount": 5
  }, {
    "LoanId": 85,
    "BookId": 61,
    "PersonId": 84,
    "LoanDate": "2021-02-09",
    "ReturnDate": "2020-11-04",
    "DueDate": "2020-12-04",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 86,
    "BookId": 48,
    "PersonId": 68,
    "LoanDate": "2022-09-21",
    "ReturnDate": "2020-07-07",
    "DueDate": "2020-02-03",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 87,
    "BookId": 66,
    "PersonId": 7,
    "LoanDate": "2022-04-19",
    "ReturnDate": "2021-08-20",
    "DueDate": "2022-08-04",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 88,
    "BookId": 1,
    "PersonId": 42,
    "LoanDate": "2020-06-04",
    "ReturnDate": "2020-03-18",
    "DueDate": "2022-05-30",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 89,
    "BookId": 28,
    "PersonId": 49,
    "LoanDate": "2022-12-15",
    "ReturnDate": "2021-06-01",
    "DueDate": "2020-02-24",
    "IsReturned": true,
    "RenewalCount": 2
  }, {
    "LoanId": 90,
    "BookId": 24,
    "PersonId": 47,
    "LoanDate": "2022-07-27",
    "ReturnDate": "2022-10-20",
    "DueDate": "2022-12-04",
    "IsReturned": true,
    "RenewalCount": 1
  }, {
    "LoanId": 91,
    "BookId": 64,
    "PersonId": 10,
    "LoanDate": "2020-11-03",
    "ReturnDate": "2022-11-03",
    "DueDate": "2021-03-18",
    "IsReturned": false,
    "RenewalCount": 4
  }, {
    "LoanId": 92,
    "BookId": 94,
    "PersonId": 29,
    "LoanDate": "2020-07-10",
    "ReturnDate": "2022-03-21",
    "DueDate": "2022-08-16",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 93,
    "BookId": 57,
    "PersonId": 29,
    "LoanDate": "2021-06-08",
    "ReturnDate": "2021-07-06",
    "DueDate": "2021-11-03",
    "IsReturned": false,
    "RenewalCount": 2
  }, {
    "LoanId": 94,
    "BookId": 72,
    "PersonId": 65,
    "LoanDate": "2021-05-16",
    "ReturnDate": "2022-09-25",
    "DueDate": "2020-09-23",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 95,
    "BookId": 95,
    "PersonId": 56,
    "LoanDate": "2021-01-07",
    "ReturnDate": "2021-06-19",
    "DueDate": "2021-10-25",
    "IsReturned": false,
    "RenewalCount": 3
  }, {
    "LoanId": 96,
    "BookId": 6,
    "PersonId": 3,
    "LoanDate": "2020-12-14",
    "ReturnDate": "2020-01-23",
    "DueDate": "2020-02-22",
    "IsReturned": true,
    "RenewalCount": 0
  }, {
    "LoanId": 97,
    "BookId": 4,
    "PersonId": 44,
    "LoanDate": "2021-12-27",
    "ReturnDate": "2020-02-05",
    "DueDate": "2020-02-16",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 98,
    "BookId": 67,
    "PersonId": 3,
    "LoanDate": "2020-01-05",
    "ReturnDate": "2022-12-27",
    "DueDate": "2020-02-20",
    "IsReturned": false,
    "RenewalCount": 5
  }, {
    "LoanId": 99,
    "BookId": 51,
    "PersonId": 94,
    "LoanDate": "2022-10-21",
    "ReturnDate": "2022-03-20",
    "DueDate": "2021-08-04",
    "IsReturned": true,
    "RenewalCount": 4
  }, {
    "LoanId": 100,
    "BookId": 97,
    "PersonId": 59,
    "LoanDate": "2021-04-13",
    "ReturnDate": "2020-12-13",
    "DueDate": "2020-07-23",
    "IsReturned": true,
    "RenewalCount": 3
  }];

export default loansList;